export default function calculateDaysPassed(date: Date){
    const timePassed = (new Date()).getTime() - date.getTime();
    return Math.floor(timePassed / (1000 /*one second*/ * 60 /*one minute*/  * 60 /*an hour*/ * 24 /*a day*/));
}